import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { trackDoctorExport } from '../../../hooks/useGoogleAnalytics';
import ShareWithDoctorModal from './ShareWithDoctorModal';

const ConsultationActions = ({ onExportPDF, onShare, onSave, patientName, reportPeriod, reportText, reportData }) => {
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    await new Promise(r => setTimeout(r, 1000));
    setSaving(false);
    setSaved(true);
    onSave?.();
    trackDoctorExport('save_consultation');
    setTimeout(() => setSaved(false), 3000);
  };

  const handleShare = () => {
    setShowShareModal(true);
    trackDoctorExport('share_doctor');
  };

  const handlePDF = () => {
    onExportPDF?.();
    trackDoctorExport('pdf_consultation');
  };

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-xl p-5">
        <h3 className="text-xs font-bold text-gray-600 uppercase tracking-wide mb-4">Export &amp; Share</h3>
        <div className="space-y-3">
          <button
            onClick={handlePDF}
            className="w-full flex items-center justify-center gap-2.5 px-4 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl transition-colors shadow-sm"
          >
            <Icon name="Download" size={18} />
            Export PDF
          </button>
          <button
            onClick={handleShare}
            className="w-full flex items-center justify-center gap-2.5 px-4 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-xl transition-colors shadow-sm"
          >
            <Icon name="Share2" size={18} />
            Share with Doctor
          </button>
          <button
            onClick={handleSave}
            disabled={saving || saved}
            className={`w-full flex items-center justify-center gap-2.5 px-4 py-3 font-semibold rounded-xl border-2 transition-colors disabled:opacity-60 ${
              saved
                ? 'bg-green-50 border-green-200 text-green-700' : 'bg-white hover:bg-gray-50 text-gray-800 border-gray-200'
            }`}
          >
            <Icon
              name={saved ? 'CheckCircle' : saving ? 'Loader' : 'Save'}
              size={18}
              className={saved ? 'text-green-600' : 'text-indigo-600'}
            />
            {saved ? 'Saved!' : saving ? 'Saving...' : 'Save Consultation Report'}
          </button>
        </div>
        <p className="text-xs text-gray-400 text-center mt-3">
          Print or share before your appointment for best results
        </p>
      </div>

      <ShareWithDoctorModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        patientName={patientName || 'Patient'}
        reportPeriod={reportPeriod || 'Last 30 days'}
        reportText={reportText}
        reportData={reportData}
      />
    </>
  );
};

export default ConsultationActions;
